module.exports = __webpack_public_path__ + "img/tmlogo.f7af0cb7.webp";